import { defineComponent as _defineComponent } from 'vue'


type Props = {
  id?: string;
  title: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    id: null,
    title: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})